module.exports = __webpack_public_path__ + "media/images/icon_area2-8378e10747f4fef3e09dea6c138bcb50.png";